import { render, staticRenderFns } from "./EditCreateTitleBox.vue?vue&type=template&id=2d3bfca4&scoped=true"
import script from "./EditCreateTitleBox.vue?vue&type=script&lang=js"
export * from "./EditCreateTitleBox.vue?vue&type=script&lang=js"
import style0 from "./EditCreateTitleBox.vue?vue&type=style&index=0&id=2d3bfca4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d3bfca4",
  null
  
)

export default component.exports